import React from "react";

const Loading = () => {
  return (
    <div className="w-32 mx-auto">
      <p className='bg-yellow-300 text-black py-2 rounded-md animate-bounce'>Loading...</p>
    </div>
  );
};

export default Loading;
